import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Clock, Eye, ChevronRight } from 'lucide-react';
import { HelpArticle } from '../data/helpArticles';
interface HelpArticleCardProps {
  article: HelpArticle;
}
export function HelpArticleCard({
  article
}: HelpArticleCardProps) {
  const Icon = article.icon;
  return <Link to={`/help/${article.slug}`} className="block h-full group" data-id="element-49">
      <Card className="h-full hover:shadow-lg transition-all duration-300 border-gray-200 group-hover:border-indigo-200" data-id="element-50">
        <CardContent className="p-6 flex flex-col h-full" data-id="element-51">
          <div className="flex items-start justify-between mb-4" data-id="element-52">
            <div className="p-2.5 bg-indigo-50 rounded-lg group-hover:bg-indigo-100 transition-colors" data-id="element-53">
              <Icon className="h-6 w-6 text-indigo-600" data-id="element-54" />
            </div>
            <Badge variant="secondary" className="bg-gray-100 text-gray-600 hover:bg-gray-200" data-id="element-55">
              {article.category}
            </Badge>
          </div>

          <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-indigo-600 transition-colors line-clamp-2" data-id="element-56">
            {article.title}
          </h3>

          <p className="text-gray-600 mb-6 flex-grow line-clamp-3" data-id="element-57">
            {article.excerpt}
          </p>

          <div className="flex items-center justify-between text-sm text-gray-500 pt-4 border-t border-gray-100" data-id="element-58">
            <div className="flex items-center space-x-4" data-id="element-59">
              <span className="flex items-center" data-id="element-60">
                <Clock className="h-4 w-4 mr-1.5" data-id="element-61" />
                {article.readTime}
              </span>
              <span className="flex items-center" data-id="element-62">
                <Eye className="h-4 w-4 mr-1.5" data-id="element-63" />
                {article.views.toLocaleString()}
              </span>
            </div>
            <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 transform group-hover:translate-x-1 transition-all" data-id="element-64" />
          </div>
        </CardContent>
      </Card>
    </Link>;
}